/**
 * Homepage entry — only runs on .home-page
 */
import './catalogTabs.js';
import { initProtectedNavLinks } from '../../helpers/protectedNav.js';
import { initNavScrollSpy } from './navScrollSpy.js';
import { initRevealOnScroll } from './revealOnScroll.js';
import { initFrameMotion3d } from './frameMotion3d.js';

function initHomepage() {
  if (!document.querySelector('.home-page') && !document.querySelector('.mkt')) return;

  initRevealOnScroll();
  initFrameMotion3d();
  initNavScrollSpy();
  initProtectedNavLinks();

  document.querySelectorAll('.home-page a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      const id = anchor.getAttribute('href')?.slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHomepage);
} else {
  initHomepage();
}

export { initHomepage };
